<template>
  <div class="wrapper">
    <div class="page_header">
      <fpHeader />
    </div>
    <div class="page_main">
      <router-view />
    </div>
    <fpFooter class="page_footer" />
    <fpSideIcon />
  </div>
</template>

<script>
export default {
  name: "filepassportApp",
  data() {
    return {
      navbar_upload: true,
      navbar_download: false
    };
  }
};

import vhCheck from "vh-check";
(function() {
  vhCheck();
})();

// デバイスを横にするとき再度読み込み
window.addEventListener("orientationchange", function() {
  window.location.reload();
});
</script>

<style src="@/assets/css/style.css"></style>
